import { clearLocalSessionCookies } from "./clearLocalSessionCookies";
import type { AuthBackend } from "./types";

let terminating = false;

export function resetSessionTerminationForTests(): void {
  terminating = false;
}

export async function terminateSession(backend: AuthBackend, loginUrl: string): Promise<void> {
  if (terminating) return;
  terminating = true;

  let signOutNavigated = false;
  try {
    await backend.signOut({ redirectTo: loginUrl });
    signOutNavigated = backend.navigatesOnSignOut;
  } catch {
    // A failed provider sign-out must not keep the user on a rejected session.
  }
  clearLocalSessionCookies();
  if (!signOutNavigated) window.location.replace(loginUrl);
}
